import React from 'react';
import FormPage from '../shared/FormPage';
import useCreateCompanyStore from '../../stores/createCompanyStore';

const UserDetailsPage = () => {
  const { formData, setFormData, isStepValid, nextStep, previousStep } = useCreateCompanyStore();
  
  const fields = [
    {
      key: 'firstName',
      label: 'First Name',
      placeholder: 'Enter your first name',
      type: 'text'
    },
    {
      key: 'lastName', 
      label: 'Last Name',
      placeholder: 'Enter your last name',
      type: 'text'
    },
    {
      key: 'email',
      label: 'Email Address',
      placeholder: 'admin@yourcompany.com',
      type: 'email'
    }
  ];

  const handleFieldChange = (fieldKey, value) => {
    setFormData(fieldKey, value);
  };

  // Individual field validation
  const getFieldValidation = () => {
    const validation = {};
    
    // First name validation
    if (formData.firstName !== undefined && formData.firstName !== '') {
      validation.firstName = formData.firstName.trim().length > 0;
    }
    
    // Last name validation
    if (formData.lastName !== undefined && formData.lastName !== '') {
      validation.lastName = formData.lastName.trim().length > 0;
    }
    
    // Email validation
    if (formData.email !== undefined && formData.email !== '') {
      validation.email = formData.email.trim().length > 0 && 
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email);
    }
    
    return validation;
  };

  return (
    <FormPage
      title="Tell us about yourself"
      subtitle="We'll need some basic information to set up your account"
      inputType="multiple"
      fields={fields}
      formData={formData}
      onFieldChange={handleFieldChange}
      fieldValidation={getFieldValidation()}
      onNext={nextStep}
      onPrevious={previousStep}
      isValid={isStepValid(3)}
      nextButtonText="Continue"
    />
  );
};

export default UserDetailsPage;